import { useMutation } from "@tanstack/react-query";
import http from "../../utils/http-common";

export function useRequestPasswordReset() {
  return useMutation({
    mutationFn: (data: { email: string }) =>
      http.post("/reset-password/request", data).then((res) => res.data),
  });
}
